import { useMemo } from "react";
import { CMSAllocation } from "@components/VaultTabs/VaultAprReports";

export type TGainAllocations = {
  [key: string]: number;
};

const initialData: TGainAllocations = {
  aave: 0,
  compound: 0,
  zircuit: 0,
  karak: 0,
  kelpdao: 0,
  hemi: 0,
  morpho: 0,
  swell: 0,
  bera: 0,
  fluid: 0,
};

const getformattedAllocations = (cmsAllocations: CMSAllocation) => {
  let aggregated: any = {};

  cmsAllocations?.allocations.forEach((allocation) => {
    const key = allocation.key;
    if (aggregated[key]) {
      aggregated[key] += +allocation.allocation;
    } else {
      aggregated[key] = +allocation.allocation;
    }
  });

  Object.keys(aggregated).map((key) => {
    aggregated[key] = Math.round(aggregated[key]);
  });

  return aggregated;
};

const useGainAllocations = (cmsAllocations: CMSAllocation[]) => {
  const allocationsFromCMS = useMemo(() => {
    return cmsAllocations && cmsAllocations.length > 0
      ? {
          ...initialData,
          ...getformattedAllocations(cmsAllocations.slice(-1)[0]),
        }
      : initialData;
  }, [cmsAllocations]);

  return { allocations: allocationsFromCMS };
};

export default useGainAllocations;
